var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4550_2355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.016 2.47485C10.9156 2.29324 10.7684 2.14184 10.5897 2.03641C10.4111 1.93097 10.2074 1.87537 9.99994 1.87537C9.7924 1.87537 9.58874 1.93097 9.41006 2.03641C9.23139 2.14184 9.08421 2.29324 8.98393 2.47485L1.43926 16.4034C1.3417 16.5802 1.2919 16.7793 1.2948 16.9811C1.29769 17.1829 1.35317 17.3805 1.45575 17.5543C1.55834 17.7282 1.70449 17.8723 1.87978 17.9724C2.05506 18.0724 2.25342 18.1251 2.45527 18.1251H17.5446C17.7464 18.1251 17.9448 18.0724 18.1201 17.9724C18.2953 17.8723 18.4415 17.7282 18.5441 17.5543C18.6466 17.3805 18.7021 17.1829 18.7051 16.9811C18.7079 16.7793 18.6581 16.5802 18.5606 16.4034L11.016 2.47485Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 12.3215V7.09827",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 15.2232C9.83976 15.2232 9.70984 15.0933 9.70984 14.933C9.70984 14.7727 9.83976 14.6428 10 14.6428",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 15.2232C10.1603 15.2232 10.2902 15.0933 10.2902 14.933C10.2902 14.7727 10.1603 14.6428 10 14.6428",
    stroke: "white",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4550_2355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarn);
export default __webpack_public_path__ + "static/media/warn.0f64666831ca42b171227bda73d156cc.svg";
export { ForwardRef as ReactComponent };